import React, { useState } from 'react';
import { array, func, object } from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { isEmpty } from 'lodash';

import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Paper from '@material-ui/core/Paper';

import template from 'url-template';
import queryString from 'query-string';

import { getActiveTabName, getCoreViewName } from '../containers/Dashboard/Navigation/NavigationHelper';
import * as BobActions from '../actions/bobActions';
import * as DashboardActions from '../actions/dashboardActions';
import { company, client, site, equipment, apps, admin } from '../data/megaMenu';

import classes from './BobNavigation.module.css';
import NavigationModal from '../containers/Dashboard/Modals/NavigationModal';

const BobNavigation = ({
    activeNavClient,
    activeNavCompany,
    activeNavEquipment,
    activeNavSite,
    companies,
    companyInfo,
    companyApplications,
    fetchNavClients,
    fetchNavEquipment,
    fetchNavSites,
    fetchSingleClient,
    fetchSingleSite,
    history,
    navClients,
    navClientsMeta,
    navEquipment,
    navEquipmentMeta,
    navSites,
    navSitesMeta,
    resetNavOptions,
    setActiveNavClient,
    setActiveNavSite,
    setActiveNavEquipment,
    setNavClient,
    setNavCompany,
    setNavEquipment,
    setNavSite,
    setCompanyTabIndex,
    setClientTabIndex,
    setEquipmentTabIndex,
    setSiteTabIndex,
    targetNavClient,
    targetNavCompany,
    targetNavEquipment,
    targetNavSite,
    currentUser,
    ...props
}) => {
    const [isShowNavModal, setNavModalOpen] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const [menuType, setMenuType] = useState(null);
    
    const [tempAppId, setTempAppId] = useState(null);
    const [tempChildId, setTempChildId] = useState(null);
    const [tempParentId, setTempParentId] = useState(null);

    const queryValues = queryString.parse(history.location.search);

    const handleToggle = () => {
        setMenuOpen(!menuOpen);
    };

    const closeNavSelectModal = () => {
        setNavModalOpen(false);
        setMenuType(null);
    };

    function handleNavClick(pathName, navType, appId, parentId, childId, viewChildId) {
        let url = template.parse(pathName);
        setTempAppId(appId);
        setTempParentId(parentId);
        setTempChildId(childId);

        const activeTab = getCoreViewName(childId);

        if (navType === 'company') {
            setActiveNavClient({});
            setActiveNavSite({});
            setActiveNavEquipment({});
            resetNavOptions('company');
            if (activeTab === 'Site System') {
                setNavModalOpen(true);
                setMenuType('site');
            } else if (!isEmpty(targetNavCompany)) {
                history.push(
                    url.expand({
                        companyId: activeNavCompany.id,
                        appId,
                        parentId,
                        childId
                    })
                );
            } else {
                setNavModalOpen(true);
                setMenuType('company');
            }
        } else if (navType === 'client') {
            setActiveNavSite({});
            setActiveNavEquipment({});
            resetNavOptions('client');
            if (activeNavClient.id) {
                fetchNavSites(activeNavClient.id);
            }
            if (activeTab === 'Site System') {
                setNavModalOpen(true);
                setMenuType('site');
            } else if (!isEmpty(targetNavCompany) && !isEmpty(targetNavClient)) {
                history.push(
                    url.expand({
                        companyId: activeNavCompany.id,
                        clientId:  activeNavClient.id,
                        appId,
                        parentId,
                        childId
                    })
                );
            } else {
                setNavModalOpen(true);
                setMenuType('client');
            }
        } else if (navType === 'site') {
            setActiveNavEquipment({});
            resetNavOptions('site');
            if (activeNavSite.id) {
                fetchNavEquipment(activeNavSite.id);
            }
            if (!isEmpty(targetNavCompany) && !isEmpty(targetNavClient) && !isEmpty(targetNavSite)) {
                history.push(
                    url.expand({
                        companyId: activeNavCompany.id,
                        clientId:  activeNavClient.id,
                        siteId:    activeNavSite.id,
                        appId,
                        parentId,
                        childId
                    })
                );
            } else {
                setNavModalOpen(true);
                setMenuType('site');
            }
        } else {
            if (!isEmpty(targetNavCompany) && !isEmpty(targetNavClient) && !isEmpty(targetNavSite) && !isEmpty(targetNavEquipment)) {
                history.push(
                    url.expand({
                        companyId:   activeNavCompany.id,
                        clientId:    activeNavClient.id,
                        siteId:      activeNavSite.id,
                        equipmentId: activeNavEquipment.id,
                        appId,
                        parentId,
                        childId,
                        viewChildId
                    })
                );
            } else {
                if (isEmpty(targetNavClient)) {
                    setActiveNavClient({});
                }
                if (isEmpty(targetNavSite)) {
                    setActiveNavSite({});
                }
                if (isEmpty(targetNavEquipment)) {
                    setActiveNavEquipment({});
                }
                setNavModalOpen(true);
                setMenuType('equipment');
            }
        }
        setMenuOpen(false);
    }

    const handleStaticNavClick = (pathName, title) => {
        let url = pathName.split('?');

        const queryStrings = url[1] ? template.parse(url[1]) : null;
        if (title === 'Reporting' || title === 'Rules' || title === 'Announcements' || title === 'Equipment & Sensor' || title === 'User Permission' || title === 'Settings' || title === 'Calculated Sensors' || title === 'Roles') {
            resetNavOptions('navigation');
        }

        if (!isEmpty(targetNavCompany)) {
            history.push({
                pathname: url[0],
                search:   queryStrings ? queryStrings.expand({ companyId: targetNavCompany.id }) : '',
                state:    { 'returnUrl': history.location, 'activeNavClient': activeNavClient, 'activeNavSite': activeNavSite, 'activeNavEquipment': activeNavEquipment }
            });
        }
        setMenuOpen(false);
    };

    const handleAppNavClick = (pathName, title) => {
        let url = template.parse(pathName);

        if (title === 'Reporting' || title === 'Rules' || title === 'Announcements' || title === 'Equipment & Sensor' || title === 'User Permission' || title === 'Settings') {
            resetNavOptions('navigation');
        }

        if (!isEmpty(targetNavCompany)) {
            history.push(
                url.expand({
                    companyId: targetNavCompany.id
                })
            );
        }
        setMenuOpen(false);
    };

    const renderAdminMenu = (item, key) => {
        var isCustomMenu = true;

        if (item.title === 'User Permission') {
            isCustomMenu = process.env.userPermissionEnabled && currentUser.isSuperUser;
        } else if (item.title === 'Settings') {
            isCustomMenu = process.env.isCompanyManagementEnabled;
        } else if (item.title === 'Equipment & Sensor') {
            if (!currentUser.isSuperUser) return;
        }
        else if (item.title === 'Calculated Sensors') {
            isCustomMenu = process.env.customCalculationEnabled;
        } else if (item.title === 'Executive Summary') {
            return;
        } else if (item.title === 'Attribute Management') {
            isCustomMenu = process.env.attributeManagementEnabled;
        } else if (item.title === 'Roles') {
            if (!currentUser.isSuperUser) {
                return;
            }
            else {
                if (!process.env.isNewRolesEnabled) return;
            }
        }

        return isCustomMenu ?
            <li key={`admin-${key}`} className={classes.listItem}>
                <span
                    aria-hidden="true"
                    role="button"
                    tabIndex={0}
                    onClick={() =>
                        handleStaticNavClick(
                            item.pathName,
                            item.title
                        )
                    }
                >
                    {item.title}
                </span>
            </li> 
            : 
            null;
    };

    return (
        <ClickAwayListener
            onClickAway={() => setMenuOpen(false)}
        >
            <div className={classes.BobNavigation}>
                <Button
                    onClick={ handleToggle }
                    className={classes.root}
                >
                    <span className={classes.root}><i className="fas fa-bars" aria-hidden="true" /></span>
                </Button>
                {
                    menuOpen ?
                        <Paper className={classes.megaNav}>
                            <div className={classes.megaNavContainer}>
                                <div className={classes.megaCompanyNavSection}>
                                    <h5 className={classes.megaNavSectionTitle}>{company.title}</h5>
                                    <ul>
                                        {company.menu.map((item, key) => {
                                            if (item.title === 'Executive Summary' && !process.env.executiveSummaryEnabled) return null;
                                            return (
                                                <li key={`company-${key}`} className={classes.listItem}>
                                                    <span
                                                        aria-hidden="true"
                                                        role="button"
                                                        tabIndex={0}
                                                        onClick={() =>
                                                            handleNavClick(
                                                                (getActiveTabName(queryValues.appId) === 'K2A Core' && item.title !== 'Health Monitor') ? item.corePathName : item.pathName,
                                                                'company',
                                                                (getActiveTabName(queryValues.appId) === 'K2A Core' && item.title !== 'Health Monitor') ? company.coreAppId : company.appId,
                                                                (getActiveTabName(queryValues.appId) === 'K2A Core' && item.title !== 'Health Monitor') ? company.coreParentId : company.parentId,
                                                                (getActiveTabName(queryValues.appId) === 'K2A Core' && item.title !== 'Health Monitor') ? item.coreChildId : item.childId
                                                            )
                                                        }
                                                    >
                                                        {item.title}
                                                    </span>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                                <div className={classes.megaNavSection}>
                                    <h5 className={classes.megaNavSectionTitle}>{client.title}</h5>
                                    <ul>
                                        {client.menu.map((item, key) => {
                                            return (
                                                <li key={`client-${key}`} className={classes.listItem}>
                                                    <span
                                                        aria-hidden="true"
                                                        role="button"
                                                        tabIndex={0}
                                                        onClick={() =>
                                                            handleNavClick(
                                                                (getActiveTabName(queryValues.appId) === 'K2A Core' && item.title !== 'Health Monitor') ? item.corePathName : item.pathName,
                                                                'client',
                                                                (getActiveTabName(queryValues.appId) === 'K2A Core' && item.title !== 'Health Monitor') ? client.coreAppId : client.appId,
                                                                (getActiveTabName(queryValues.appId) === 'K2A Core' && item.title !== 'Health Monitor') ? client.coreParentId : client.parentId,
                                                                (getActiveTabName(queryValues.appId) === 'K2A Core' && item.title !== 'Health Monitor') ? item.coreChildId : item.childId
                                                            )
                                                        }
                                                    >
                                                        {item.title}
                                                    </span>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                                <div className={classes.megaNavSection}>
                                    <h5 className={classes.megaNavSectionTitle}>{site.title}</h5>
                                    <ul>
                                        {site.menu.map((item, key) => {
                                            return (
                                                <li key={`site-${key}`} className={classes.listItem}>
                                                    <span
                                                        aria-hidden="true"
                                                        role="button"
                                                        tabIndex={0}
                                                        onClick={() =>
                                                            handleNavClick(
                                                                (getActiveTabName(queryValues.appId) === 'K2A Core' && item.title !== 'Health Monitor') ? item.corePathName : item.pathName,
                                                                'site',
                                                                (getActiveTabName(queryValues.appId) === 'K2A Core' && item.title !== 'Health Monitor') ? site.coreAppId : site.appId,
                                                                (getActiveTabName(queryValues.appId) === 'K2A Core' && item.title !== 'Health Monitor') ? site.coreParentId : site.parentId,
                                                                (getActiveTabName(queryValues.appId) === 'K2A Core' && item.title !== 'Health Monitor') ? item.coreChildId : item.childId
                                                            )
                                                        }
                                                    >
                                                        {item.title}
                                                    </span>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                                <div className={classes.megaNavSection}>
                                    <h5 className={classes.megaNavSectionTitle}>{equipment.title}</h5>
                                    <ul>
                                        {equipment.menu.map((item, key) => {
                                            return (
                                                <li key={`equipment-${key}`} className={classes.listItem}>
                                                    <span
                                                        aria-hidden="true"
                                                        role="button"
                                                        tabIndex={0}
                                                        onClick={() =>
                                                            handleNavClick(
                                                                item.pathName,
                                                                'equipment',
                                                                equipment.appId,
                                                                equipment.parentId,
                                                                item.childId,
                                                                item.viewChildId
                                                            )
                                                        }
                                                    >
                                                        {item.title}
                                                    </span>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                                <div className={classes.megaNavStaticSection}>
                                    <h5 className={classes.megaNavSectionTitle}>{apps.title}</h5>
                                    <ul>
                                        {apps.menu.map((item, key) => {
                                            return (
                                                <li key={`apps-${key}`} className={classes.listItem}>
                                                    {
                                                        item.title === 'Rules' || item.title === 'Reporting' || (item.title === 'Service' && process.env.navServiceRequestEnabled && companyApplications.includes('Service')) ?
                                                            <span
                                                                aria-hidden="true"
                                                                role="button"
                                                                tabIndex={0}
                                                                onClick={() =>
                                                                    handleAppNavClick(
                                                                        item.dashboardPathName,
                                                                        item.title
                                                                    )
                                                                }
                                                            >
                                                                {item.title}
                                                            </span> 
                                                            : <Link to={`${item.pathName}?company=${queryValues.company}`}>{item.title}</Link>
                                                    }
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                                <div className={classes.megaNavStaticSection}>
                                    <h5 className={classes.megaNavSectionTitle}>{admin.title}</h5>
                                    <ul>
                                        {admin.menu.map((item, key) => {
                                            return (
                                                renderAdminMenu(item, key) 
                                            );
                                        })}
                                    </ul>
                                </div>
                            </div>
                        </Paper> :
                        null
                }
                { isShowNavModal ?
                    <NavigationModal
                        menuType={menuType}
                        closeNavSelectModal={closeNavSelectModal}
                        tempAppId={tempAppId}
                        tempChildId={tempChildId}
                        tempParentId={tempParentId}
                    />
                    :
                    ''
                }
            </div>
        </ClickAwayListener>
    );
};

BobNavigation.defaultProps = {
    companies:          [],
    companyInfo:        {},
    fetchNavClients:    () => {},
    fetchNavSites:      () => {},
    fetchNavEquipment:  () => {},
    navClients:         [],
    navClientsMeta:     {},
    navEquipment:       [],
    navEquipmentMeta:   {},
    navSites:           [],
    navSitesMeta:       {},
    resetNavOptions:    () => {},
    setNavClient:       () => {},
    setNavCompany:      () => {},
    setNavEquipment:    () => {},
    setNavSite:         () => {},
    targetNavClient:    {},
    targetNavCompany:   {},
    targetNavEquipment: {},
    targetNavSite:      {},
    currentUser:        {}
};

BobNavigation.propTypes = {
    companies:          array,
    companyInfo:        object,
    fetchNavClients:    func,
    fetchNavSites:      func,
    fetchNavEquipment:  func,
    navClients:         array,
    navClientsMeta:     object,
    navEquipment:       array,
    navEquipmentMeta:   object,
    navSites:           array,
    navSitesMeta:       object,
    resetNavOptions:    func,
    setNavClient:       func,
    setNavCompany:      func,
    setNavEquipment:    func,
    setNavSite:         func,
    targetNavClient:    object,
    targetNavCompany:   object,
    targetNavEquipment: object,
    targetNavSite:      object,
    currentUser:        object
};

const mapStateToProps = state => {
    return {
        activeNavCompany:    state.bob.activeNavCompany,
        activeNavClient:     state.bob.activeNavClient,
        activeNavEquipment:  state.bob.activeNavEquipment,
        activeNavSite:       state.bob.activeNavSite,
        companies:           state.core.companies,
        companyInfo:         state.companyInfo,
        companyApplications: state.bob.companyApplications,
        navClients:          state.bob.navClients,
        navClientsMeta:      state.bob.navClientsMeta,
        navEquipment:        state.bob.navEquipment,
        navEquipmentMeta:    state.bob.navEquipmentMeta,
        navSites:            state.bob.navSites,
        navSitesMeta:        state.bob.navSitesMeta,
        targetNavClient:     state.bob.targetNavClient,
        targetNavCompany:    state.bob.targetNavCompany,
        targetNavEquipment:  state.bob.targetNavEquipment,
        targetNavSite:       state.bob.targetNavSite,
        currentUser:         state.currentUser
    };
};

const mapDispatchToProps = {
    ...DashboardActions,
    ...BobActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BobNavigation));
